import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import UtentiTableRow from './UtentiTableRow'
import TablePager from '../TablePager'
import TableColumnOrdered from '../TableColumnOrdered'
import PropTypes from 'prop-types';

class UtentiTable extends Component {
    constructor(props) {
        super(props);
        let rv = this.updateData(props.count, props.rowperpage);
        this.state = {
            pages: rv.pages,
            firstPage: 1,
            lastPage: rv.lastPage,
        };

        this.onChangePage = this.onChangePage.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let rv = this.updateData(nextProps.count, nextProps.rowperpage);
        this.setState(rv);
    }

    updateData(count, rowperpage){
        let lastPage = Math.ceil(count / rowperpage);
        let pages = [];
        for (let i = 1; i <= lastPage; i++) {
            pages.push(i);
        }
        return {pages, lastPage}
    }

    onChangePage(newpage) {
        switch (newpage)
        {
            case "P":
                if (this.props.page > this.state.firstPage){
                    this.props.onChangePage(this.props.page - 1);
                }
                break;
            case "N":
                if (this.props.page < this.state.lastPage){
                    this.props.onChangePage(this.props.page + 1);
                }
                break;
            default:
                if (this.props.page !== newpage){
                    this.props.onChangePage(newpage);
                }
                break;
        }
    }

    render() {
        let btnNuovoUtente = null;
        if (this.props.readOnly == false){
            btnNuovoUtente =<Link to={`/app/utenti/new`}>
                    <div className="ui left floated small primary labeled icon button">
                        <i className="plus icon"></i> Nuovo Utente
                    </div>
                </Link>
        }
        return (
            <div className="ep-outer-table">
                <div className="ep-inner-scrollable-table">
                    <table className="ui striped sortable celled compact table">
            <thead>
            <tr><th colSpan="5">
                {btnNuovoUtente}

                <a href="#" onClick={(ev) => (this.props.onChangeOrder(''))}>
                    <i className="sort icon"></i> Ripristina ordinamento standard
                </a>
                
                <TablePager
                    pages={this.state.pages} page={this.props.page}
                    firstPage={this.state.firstPage} lastPage={this.state.lastPage}
                    onChangePage={this.onChangePage}
                />
            </th>
            </tr>
            <tr>
                <TableColumnOrdered
                    name="id"
                    orderActive={this.props.tableOrderingField === "id"}
                    orderFields="idUtente"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >ID</TableColumnOrdered>
                <TableColumnOrdered
                    name="username"
                    orderActive={this.props.tableOrderingField === "username"}
                    orderFields="username"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Username</TableColumnOrdered>
                <TableColumnOrdered
                    name="nome"
                    orderActive={this.props.tableOrderingField === "nome"}
                    orderFields="nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Nome</TableColumnOrdered>
                <TableColumnOrdered
                    name="roleAdmin"
                    orderActive={this.props.tableOrderingField === "roleAdmin"}
                    orderFields="roleAdmin"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Admin</TableColumnOrdered>
                <TableColumnOrdered
                    name="attivo"
                    orderActive={this.props.tableOrderingField === "attivo"}
                    orderFields="attivo"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Attivo</TableColumnOrdered>
                <th className="no-print"></th>
            </tr>
            </thead>
            <tbody>
            {this.props.items.map((utente) => (
                <UtentiTableRow
                    utente={utente}
                    key={utente.idUtente}
                    onDeleteItem={this.props.onDeleteItem}
                    readOnly={this.props.readOnly}
                />
            ))}
            </tbody>
            <tfoot>
            </tfoot>
        </table>
                </div>
            </div>)
    }
}

UtentiTable.PropTypes = {
    items: PropTypes.array,
    count: PropTypes.number,
    page: PropTypes.number,
    rowperpage: PropTypes.number,
    tableOrderingField: PropTypes.string,
    tableOrderingDirection: PropTypes.oneOf(['A', 'D']),
    onChangePage: PropTypes.func,
    onChangeOrder: PropTypes.func,
    onDeleteItem: PropTypes.func,
    readOnly: PropTypes.bool
}
export default UtentiTable;




/** WEBPACK FOOTER **
 ** ./src/components/utenti/UtentiTable.js
 **/